import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Gastos } from 'src/app/Models/gastos/gastos';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { InfoComponent } from '../objects/info/info/info.component';
import { LoadingComponent } from '../objects/loading/loading.component';
import { Ingreso } from 'src/app/Models/ingreso/ingreso';
import { SearchFacturaComponent } from '../compras/search-factura/search-factura.component';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Factura } from 'src/app/Models/factura/factura';
import { Personal } from 'src/app/Models/personal/personal';

@Component({
  selector: 'app-ingresos',
  templateUrl: './ingresos.component.html',
  styleUrls: ['./ingresos.component.css']
})
export class IngresosComponent implements OnInit {

  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild(SearchFacturaComponent, null) modalfactura: SearchFacturaComponent;
  public usuario: any;
  public ingreso: Ingreso = new Ingreso();
  public alertType: AlertType = new AlertType();
  public options: ALertOption = new ALertOption();
  public index: number = 0;
  public numitem: number = 0;
  public tiposgastos: any[] = [];
  public pagarticulo: any;
  public formapagos: any[] = []
  public filtro: Filtro = new Filtro()
  public factura: Factura = new Factura()
  public listapersonal: Personal[] = [];
  public personal: Personal = new Personal()
  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: Router) { }

  ngOnInit() {
    this.title.setTitle('Cobranzas | Sistema de ventas');
    this.usuario = this.auth.getCurrentUser();
    this.ingreso.fecha = moment(new Date()).format('YYYY-MM-DD')
    this.ingreso.hora = moment(new Date()).format('HH:mm:ss')
    this.ingreso.estado = "emitido";
    this.ingreso.idtipogasto = '10'
    this.factura.serie = '0'
    this.factura.numero = 0
    console.log(this.usuario);
    console.log(this.usuario.idpersonal.idpersonal);

    this.getFormaPagos();
    this.getPersonal();
    if (!(this.usuario.idpersonal.idnivel != 2)) {
      this.getliquidacion(this.usuario.idpersonal.idpersonal);
    }

  }

  getPersonal() {
    this.data.GetSimple(this.data.api.personal).subscribe((r) => {
      this.listapersonal = r
    })
  }

  getTiposGastos() {
    this.data.GetSimple(this.data.api.tiposgastos).subscribe(r => {
      this.tiposgastos = r
      console.log(r)
    })
  }

  getFormaPagos() {
    this.data.GetSimple(this.data.api.mediopago).subscribe(r => this.formapagos = r)
  }

  getliquidacion(idpersonal: any) {

    const datapersonal = { 'fecha': this.ingreso.fecha, 'idpersonal': idpersonal }
    console.log(datapersonal);

    this.data.Post('getLiqGasto', datapersonal).subscribe((data) => {
      // Manejar la respuesta exitosa
      this.ingreso.idliquida = data.idliquida
      console.log('Liquidación obtenida:', data);
    },
      (error) => {
        // Manejar el error de obtener la liquidación
        console.error('Error al obtener la liquidación:', error);
        // Si no se puede obtener la liquidación, cerrar sesión y redirigir a la página de inicio de sesión
        this.usuario.idpersonal.idnivel != 2 ? this.data.notify("Se necesita crear una liquidacion.", "Liquidacion no encontrada.", this.data.alertType.info) : this.auth.logoutUser()
      }
    );

  }

  updateFactura(factura: Factura) {
    factura.estado = 'CAN';
    const payload = { estado: 'CAN' }
    this.data.Patch(this.data.api.factura, factura.idfactura.toString(), payload).subscribe(r => console.log(r.message, r))
  }

  Guardaringreso() {
    console.log(this.ingreso);

    if (!this.ingreso.idfactura) {
      return this.data.notify("Debe seleccionar un pedido", "Error", this.data.alertType.error)
    }

    this.data.Post(this.data.api.ingreso, this.ingreso).subscribe((data) => {
      // Manejar la respuesta exitosa
      console.log('Ingreso guardado:', data);
      this.updateFactura(this.factura)
      this.data.notify("Operacion exitosa", "Exito", this.data.alertType.success)
      this.factura = new Factura()
      this.ingreso.concepto = ""
      this.ingreso.total = 0;

    },
      (error) => {
        // Manejar el error de obtener la liquidación
        console.error('Error al obtener la liquidación:', error);
        this.data.notify("Operacion fallida", "Error", this.data.alertType.error)
      }
    );

  }

  showmodalfactu() {
    this.filtro.estado = 'EMI'
    if (this.usuario.idpersonal.idnivel == 2) {
      this.filtro.idvende = this.usuario.idpersonal.idpersonal.toString()
    } else if (this.personal.idpersonal) {
      this.filtro.idvende = this.personal.idpersonal.toString()
    } else {
      this.filtro.idvende = null
    }
    this.modalfactura.filtro = this.filtro
    this.modalfactura.facturas = []
    this.modalfactura.show(() => {
      if (this.modalfactura.factura) {
        this.factura = this.modalfactura.factura
        this.ingreso.total = this.factura.tarjetachq
        this.ingreso.idfactura = this.factura.idfactura.toString()
      }
    })
  }
}
